<template>
  <CHeader with-subheader class="fixed-top app-header-custom role-theme-header">
    <CToggler
      in-header
      class="header-menu-toggle role-header-toggle ml-2 header-toggle-hidden"
      @click="$store.commit('toggleUnifiedSidebar')"
    />

    <CHeaderBrand class="header-brand-hidden" to="/user">
      <div class="d-flex align-items-center">
        <img class="logo-custom pr-2 py-1" src="@/assets/logo.svg">
        <div>
          <p class="font-weight-bold mb-0 h5 brand-title text-mfu-red">MFU</p>
          <p class="font-weight-bold mb-0 brand-subtitle text-muted">{{ $t('brand.maintenanceShort') }}</p>
        </div>
      </div>
    </CHeaderBrand>

    <div class="desktop-system-title">{{ $t('login.title') }} <span>{{ $t('login.subtitle') }}</span></div>
    <RoleDesktopTopNav role="user" />

    <CHeaderNav class="pr-2 pr-md-3 d-flex align-items-center ml-auto flex-nowrap user-profile-nav">
      <NotificationDropdown class="mr-2 flex-shrink-0" />
      <LanguageSwitcher class="mr-2 flex-shrink-0" />
      <TheHeaderDropdownAccnt class="flex-shrink-0"/>
    </CHeaderNav>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from './UheaderDropdownAccnt'
import LanguageSwitcher from '@/components/common/LanguageSwitcher.vue'
import RoleDesktopTopNav from '@/components/common/RoleDesktopTopNav.vue'
import NotificationDropdown from '@/components/common/NotificationDropdown.vue'
import { mapGetters } from "vuex";

export default {
  name: 'TheHeader',
  components: {
    TheHeaderDropdownAccnt,
    LanguageSwitcher,
    RoleDesktopTopNav,
    NotificationDropdown,
  },
  computed: {
    ...mapGetters("auth", ["profile", "role"])
  },
}
</script>

<style scoped>
.header-toggle-hidden, .header-brand-hidden { display: none !important; }
.desktop-system-title { display: flex; flex: 0 1 auto; flex-direction: column; justify-content: center; min-width: 0; max-width: 260px; margin-left: 14px; color: #1e40af; font-size: 14px; font-weight: 800; line-height: 1.2; white-space: nowrap; }
.desktop-system-title span { color: #64748b; font-size: 10px; font-weight: 600; }
@media (min-width: 1201px) {
  .desktop-system-title { min-width: 190px; max-width: 240px; margin-left: 16px; font-size: 15px; line-height: 1.25; }
  .desktop-system-title span { font-size: 11px; }
}
@media (max-width: 480px) {
  .desktop-system-title {
    flex: 1 1 auto;
    margin-left: 12px;
    font-size: clamp(14px, 4vw, 16px);
    line-height: 1.18;
  }
  .desktop-system-title span {
    margin-top: 2px;
    font-size: clamp(10px, 2.8vw, 11.5px);
  }
}
.app-header-custom {
  background: #ffffff !important;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03) !important;
  border-top: 0 !important;
  border-right: 0 !important;
  border-bottom: 1px solid rgba(37, 99, 235, 0.12) !important;
  border-left: 0 !important;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  height: 76px;
}

.text-mfu-red {
  color: #1e40af !important;
}

.brand-subtitle {
  font-size: 11px;
  letter-spacing: 0.5px;
}

.user-profile-nav {
  min-width: 0;
  flex-shrink: 1;
}

.my-text-style {
  font-family: 'Sarabun', sans-serif;
  font-size: 14px; 
  color: #333333; 
  font-weight: bold; 
  line-height: 1.5; 
  letter-spacing: 0.5px;
  white-space: nowrap;
  text-align: right;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (min-width: 1400px) {
  .my-text-style {
    max-width: 230px;
    font-size: 15px;
  }
}

.logo-custom {
  height: 52px;
}

.brand-title {
  font-size: 1.35rem;
}

.app-header-custom ::v-deep .c-avatar {
  width: 46px;
  height: 46px;
}

.app-header-custom ::v-deep .header-menu-toggle:focus,
.app-header-custom ::v-deep .header-menu-toggle:focus-visible,
.app-header-custom ::v-deep .header-menu-toggle:active {
  outline: none !important;
  border-color: transparent !important;
  box-shadow: none !important;
}

.profile-name-mobile {
  font-size: 11px;
  font-weight: bold;
  color: #333333;
  max-width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 768px) {
  .app-header-custom {
    height: 64px;
  }

  .logo-custom {
    height: 40px;
  }
  
  .brand-title {
    font-size: 1rem;
  }

  .brand-subtitle {
    max-width: 116px;
    overflow: hidden;
    font-size: 8px;
    line-height: 1.15;
    letter-spacing: 0.15px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .app-header-custom ::v-deep .c-avatar {
    width: 40px;
    height: 40px;
  }
}

@media (max-width: 1200px) {
  .header-menu-toggle {
    display: none !important;
  }
}
</style>
